import { Injectable } from '@angular/core';
import { GenericAkitaHTTPService, HttpOptions } from '../../service/generic-akita-http.service';
import { HttpClient } from '@angular/common/http';
import { NetworkService } from '../../service/network.service';
import { CrowdFlowMotionPatternAlert } from '../../model/crowd-flow-alert';

@Injectable({
  providedIn: 'root'
})
export class AkitaHTTPCrowdFlowMotionPatternAlert extends GenericAkitaHTTPService<CrowdFlowMotionPatternAlert> {
  constructor(http: HttpClient, networkService: NetworkService) {
    const options: HttpOptions = {
      params: {
        type: 'CrowdFlowMotionPatternAlert',
        options: 'keyValues',
        limit: '50'
      }
    };
    super(http, networkService, '/v2/entities/', 'CrowdFlowMotionPatternAlert', options);
  }
}
